import { useState, useEffect } from "react";
import api from "@/lib/api";

export default function Sparkline({ ticker, height = 40 }) {
  const [points, setPoints] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!ticker) return;
    api.get(`/history/${ticker}`).then((r) => { if (alive) setPoints(r.data.points || []); }).catch(() => { if (alive) setPoints([]); });
    return () => { alive = false; };
  }, [ticker]);

  if (points === null) {
    return <div className="h-10 flex items-center"><div className="h-px w-full bg-[var(--border)] animate-pulse" /></div>;
  }
  if (!points.length) {
    return <div className="h-10 flex items-center text-[10px] text-[var(--text-muted)] font-mono-data">grafik tidak tersedia</div>;
  }

  const w = 240;
  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;
  const up = points[points.length - 1] >= points[0];
  const color = up ? "var(--bull)" : "var(--bear)";
  const step = w / (points.length - 1 || 1);
  const coords = points.map((p, i) => [i * step, height - ((p - min) / range) * (height - 6) - 3]);
  const path = coords.map((c, i) => `${i === 0 ? "M" : "L"}${c[0].toFixed(1)},${c[1].toFixed(1)}`).join(" ");
  const area = `${path} L${w},${height} L0,${height} Z`;
  const gid = `sg-${ticker}`;

  return (
    <svg viewBox={`0 0 ${w} ${height}`} preserveAspectRatio="none" className="w-full" style={{ height }} data-testid={`sparkline-${ticker}`}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.28" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gid})`} />
      <path d={path} fill="none" stroke={color} strokeWidth="1.6" vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
